import React, { useState, useEffect } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import './NotificationManager.css';

interface NotificationManagerProps {
  className?: string;
}

const NotificationManager: React.FC<NotificationManagerProps> = ({ className = '' }) => {
  const {
    isSupported,
    permission,
    isRequesting,
    requestPermission,
    showHeadacheReminder,
    showTensionReminder,
    showReminderNotification
  } = useNotifications();

  const [isExpanded, setIsExpanded] = useState(false);

  const handleRequestPermission = async () => {
    const granted = await requestPermission();
    if (granted) {
      showReminderNotification('¡Notificaciones activadas! Te ayudaremos a recordar tus registros.');
    }
  };

  const testHeadacheNotification = () => {
    showHeadacheReminder();
  };

  const testTensionNotification = () => {
    showTensionReminder();
  };

  if (!isSupported) {
    return null;
  }

  return (
    <div className={`notification-manager ${className}`}>
      <button
        className="notification-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
        title="Gestionar notificaciones"
      >
        🔔
        {permission === 'granted' && <span className="notification-badge">✓</span>}
      </button>

      {isExpanded && (
        <div className="notification-panel">
          <div className="notification-header">
            <h4>Notificaciones</h4>
            <button 
              className="close-btn"
              onClick={() => setIsExpanded(false)}
            >
              ✕
            </button>
          </div>

          <div className="notification-content">
            {permission === 'default' && (
              <div className="notification-section">
                <p>Activa las notificaciones para recibir recordatorios útiles</p>
                <button
                  className="permission-btn"
                  onClick={handleRequestPermission}
                  disabled={isRequesting}
                >
                  {isRequesting ? 'Solicitando...' : 'Activar notificaciones'}
                </button>
              </div>
            )}

            {permission === 'denied' && (
              <div className="notification-section">
                <p>Las notificaciones están bloqueadas. Puedes habilitarlas desde la configuración de tu navegador.</p>
              </div>
            )}

            {permission === 'granted' && (
              <div className="notification-section">
                <p>✅ Notificaciones activadas</p>
                
                <div className="notification-tests">
                  <h5>Probar notificaciones:</h5>
                  <div className="test-buttons">
                    <button
                      className="test-btn"
                      onClick={testHeadacheNotification}
                    >
                      🤕 Recordatorio de dolor
                    </button>
                    <button
                      className="test-btn"
                      onClick={testTensionNotification}
                    >
                      💓 Recordatorio de tensión
                    </button>
                  </div>
                </div>

                <div className="notification-info">
                  <small>
                    Las notificaciones te ayudarán a recordar registrar tus dolores y medir tu tensión arterial regularmente.
                  </small>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationManager;